import { CmsProtectionUpsellPanel } from '../../models/protection-upsell/cms-protection-upsell-panel.interface';

export const mockCmsProtectionUpsellPanel: CmsProtectionUpsellPanel = {
  averageProtectedRepairCost: '129',
  averageUnprotectedRepairCost: '0',
  protectionUpsellTitle: 'Add extra protection to include',
};
